/* eslint-disable import/no-unresolved */
import { useTranslation } from 'react-i18next';
import Airplane from '../../../../assets/icons/flightBrief/airplane.svg?react';
import typo from '../../../atoms/flightBriefPdf/flightBriefTypography.module.css';
import FlightBriefAirportInfo from '../FlightBriefAirportInfo/FlightBriefAirportInfo';
import styles from './FlightBriefTripLine.module.css';

/**
 * Trip line for the flight brief PDF: departure and arrival airports around
 * the flight duration separator. Data is mapped at this boundary from the
 * shared flight brief payload.
 * @param {object} props
 * @param {SharedFlightBrief} props.flightBrief - Shared flight brief payload.
 * @param {string} props.locale - Active locale for date/time formatting.
 * @returns {JSX.Element}
 */
function FlightBriefTripLine({ flightBrief, locale }) {
  const { t } = useTranslation(undefined, { lng: locale });
  const departure = flightBrief?.departure;
  const arrival = flightBrief?.arrival;

  return (
    <div className={styles['trip-line']}>
      <FlightBriefAirportInfo destination={departure} type="departure" locale={locale} />

      <div className={styles.center}>
        <div className={styles['city-spacer']} aria-hidden="true" />
        <div className={styles.line}>
          <span className={styles.rule} />
          <span className={styles['plane-icon']}><Airplane /></span>
          <span className={styles.rule} />
        </div>
        <div className={styles['bottom-spacer']} aria-hidden="true" />
        <div className={styles['flight-time-info']}>
          {flightBrief?.flightDuration ? (
            <p className={styles.duration}>{flightBrief.flightDuration}</p>
          ) : null}
          <p className={`${styles['flight-time-label']} ${typo['neutral-500']} ${typo.uppercase}`}>
            {t('sharedFlightBrief.pdf.flightTime')}
          </p>
        </div>
      </div>

      <FlightBriefAirportInfo destination={arrival} type="arrival" locale={locale} />
    </div>
  );
}

export default FlightBriefTripLine;
